import {authHeader} from "../helpers/auth-header";

export const formService = {
    offerMaterials,
    offerFinished,
    requestMaterials,
    requestFinished
};

function offerMaterials(supplies){
    return submitSupplies(supplies)
}

function offerFinished(supplies){
    return submitSupplies(supplies)
}

function requestMaterials(demands){
    return submitDemands(demands)
}

function requestFinished(demands){
    return submitDemands(demands)
}

function submitSupplies(supplies){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ supplies })
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/supplies', requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function submitDemands(demands){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ demands })
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/demands', requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return Promise.reject(data);
        }
        return data;
    });
}
